module.exports = __webpack_public_path__ + "static/pro-banner3@2x-5a98339bf1f5ef9ed105defa17d73094.jpg";